import { useContext } from 'react';

import { fmt } from 'IntlWrapper/IntlWrapper';
import { openModal } from 'utils/modal';
import { isUserAuthorized } from 'utils/helpers';
import { OpsControl } from 'contexts/ops-control.context';
import { FOUND_IT, STAR_LIABLE } from 'constants/lost-or-damaged';
import { markAsFound, markStarAsLiable } from 'services/ops-control';
import { ACL_MATRIX } from 'common/permissions';
import aclMatrix from 'common/aclMatrix';

import BRButton from 'components/BRButton/BRButton';
import LostOrDamagedModal from 'containers/Deliveries/DeliveriesSearch/components/LostOrDamagedModal/LostOrDamagedModal';

import { ReactComponent as Star } from 'assets/bosta-icons/Out for Delivery.svg';

export const PendingOnHubActions = ({ order }) => {
  const { allHubs } = useContext(OpsControl);
  const canMarkStarAsLiable = isUserAuthorized(aclMatrix.DELIVERIES, [
    ACL_MATRIX.DELIVERY_MARK_STAR_AS_LIABLE_FOR_LOST_ORDER
  ]);

  const openStarLiableModal = () => {
    openModal(LostOrDamagedModal, {
      headerTitle: fmt({
        id: 'ops_control.lost_orders.table_columns.star_liable'
      }),
      allHubs,
      delivery: order,
      modalType: STAR_LIABLE,
      confirmEndPoint: markStarAsLiable
    });
  };

  const openFoundItModal = () => {
    openModal(LostOrDamagedModal, {
      headerTitle: fmt({
        id: 'ops_control.lost_orders.table_columns.found_it'
      }),
      allHubs,
      delivery: order,
      modalType: FOUND_IT,
      confirmEndPoint: markAsFound
    });
  };

  return (
    <div className="br-lost-orders__action-buttons-wrapper">
      <BRButton
        type={'outline'}
        className={'br-lost-orders__found-it'}
        label={fmt({
          id: 'ops_control.lost_orders.table_columns.found_it'
        })}
        onClick={openFoundItModal}
      />
      <BRButton
        className={'br-lost-orders__star-liable'}
        type={'basic'}
        label={fmt({
          id: 'ops_control.lost_orders.table_columns.star_liable'
        })}
        disabled={!canMarkStarAsLiable}
        onClick={openStarLiableModal}
        prefixIcon={<Star />}
      />
    </div>
  );
};
